module.exports = __webpack_public_path__ + "static/media/facebook.20eb52f6.svg";